import * as React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import './style.scss';
import { useI18next } from 'gatsby-plugin-react-i18next';

const Button = ({
  href,
  children,
  size = 'medium',
  theme = 'primary',
  external = false,
  target,
  lang,
  classes = "",  
  onClick = null,
}) => {
  const className = `button button--${theme} button--${size} ${classes}`
  const { language } = useI18next();
  return (
    href
      ? ( external ?
          <a href={href} target={target ? target : "_self"} className={className}>{children}</a>
        :
          <Link language={lang ? lang : language} target={target ? target : "_self"} to={href} className={className}>{children}</Link>
        )
      : <button onClick={onClick} className={className}>{children}</button >
  )
}

export default Button;
